export const getSingleAdvert = (payload?: any) => ({
    type: "@saga/GET_SINGLE_ADVERT",
    payload
});

